import { IFilter } from "@saleor/components/Filter";
import { FilterOpts } from "@saleor/types";
import { createBooleanField } from "@saleor/utils/filters/fields";
import { defineMessages, IntlShape } from "react-intl";

export enum PageheaderFilterKeys {
  isDefault="isDefault"
}

export interface PageheaderListFilterOpts {
  isDefault: FilterOpts<boolean>;
}

const messages = defineMessages({
  isDefault: {
    defaultMessage: "isDefault",
    description: "When Pageheader isDefault"
  },
  active: {
    defaultMessage: "Active"
  },
  inactive: {
    defaultMessage: "Inactive"
  }
});

export function createFilterStructure(
  intl: IntlShape,
  opts: PageheaderListFilterOpts
): IFilter<PageheaderFilterKeys> {
  return [
    {
      ...createBooleanField(
        PageheaderFilterKeys.isDefault,
        intl.formatMessage(messages.isDefault),
        opts.isDefault.value,
        {
          negative: intl.formatMessage(messages.inactive),
          positive: intl.formatMessage(messages.active)
        }
      ),
      active: opts.isDefault.active
    }
  ];
}
